import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from '@mui/material';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useAppDispatch } from '@application/store/useStore';
import { getPartnerEventDetailsAsync } from '@application/features/partnerEvent/partnerEventThunk';
import { getItemStyle } from '../cUtils';
export const CalendarItemChip = ({ item, onClick, sx = {}, isSponsorshipDetailsCalendarTab = false }) => {
    const { color, variant } = getItemStyle(item);
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const sponsorshipId = params?.id;
    const dispatch = useAppDispatch();
    const isSponsorshipsPage = location.pathname === '/sponsorships' || (location.pathname.startsWith('/sponsorships') && !location.pathname.includes('sponsorship-details') && !location.pathname.includes('new-sponsorship'));
    const handleClick = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        // If in sponsorship details calendar tab and event has eventId, navigate to sponsorship event detail
        if (isSponsorshipDetailsCalendarTab && item.eventId && sponsorshipId) {
            navigate(`/sponsorship-details/${sponsorshipId}/ticket-detail/${item.eventId}`);
            return;
        }
        // If in sponsorships grid calendar (main page), fetch event details to get partnerId and navigate
        if (isSponsorshipsPage && item.eventId) {
            try {
                const eventDetails = await dispatch(getPartnerEventDetailsAsync(item.eventId)).unwrap();
                const partnerId = eventDetails?.partnerId;
                if (partnerId) {
                    navigate(`/sponsorship-details/${partnerId}/ticket-detail/${item.eventId}`);
                    return;
                }
            }
            catch (error) {
                // If fetching fails, fall back to onClick handler
                console.error('Failed to fetch event details:', error);
            }
        }
        // Default: use onClick handler (opens dialog)
        if (onClick) {
            onClick();
        }
    };
    const isClickable = onClick || (isSponsorshipDetailsCalendarTab && item.eventId) || (isSponsorshipsPage && item.eventId);
    return (_jsx(Chip, { size: 'small', label: item.title, color: color, variant: variant, sx: {
            width: '100%',
            px: '3px',
            cursor: isClickable ? 'pointer' : 'default',
            mb: 0.5,
            justifyContent: 'flex-start',
            '& .MuiChip-label': {
                width: '100%',
                //   maxWidth: 170,
                textAlign: 'left',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            },
            ...sx
        }, onClick: handleClick }));
};
